// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1t5X4","ranges":"BmiRanges_ranges__17Y8I"};